import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import './Version.scss';

const Version = ({ number }) => {
  const isInitialized = useSelector(state => state.data.initialized);
  const isDebug = useSelector(state => state.config.debug);
  const [visible, setVisibility] = useState(false);

  const timeout = 3; // In Seconds

  useEffect(() => {
      if(isInitialized){
        setVisibility(true);
      }
  }, [isInitialized]);

  useEffect(() => {
    const timer = setTimeout(() => setVisibility(false), timeout * 1000);
    return () => clearTimeout(timer);
  }, [visible]);

  useEffect(() => {
    function Keydown(e) {
      if (e.key === 'v') {
        setVisibility(true);
      }
    }
    document.addEventListener('keydown', Keydown, { passive: true });

    return () => {
      document.removeEventListener('keydown', Keydown);
    };
  }, []);

  if (isInitialized === false || visible === false || isDebug === false) {
    return null;
  }

  return (
    <div className="version">
      <div className="text">{number}</div>
    </div>
  );
};

export default Version;
